import type { RouteRecordName } from 'vue-router'
import { useRouter } from 'vue-router'
import { computed, type ComputedRef } from 'vue'

export function useIsOnRoute(routes: RouteRecordName[]): ComputedRef<boolean> {
    const router = useRouter()

    return computed(() => {
        if (!router.currentRoute.value.name) {
            return false
        }

        return routes.includes(router.currentRoute.value.name)
    })
}
